var CustomerSocketTypes = /* @__PURE__ */ ((CustomerSocketTypes2) => {
  CustomerSocketTypes2["userStateChanged"] = "user-state-changed";
  CustomerSocketTypes2["userLimitReached"] = "user-limit-reached";
  CustomerSocketTypes2["compPointsChanged"] = "comp-points-changed";
  CustomerSocketTypes2["broadcastStop"] = "broadcast-stop";
  CustomerSocketTypes2["notification"] = "notification";
  CustomerSocketTypes2["ondatoVerificationResult"] = "user-ondato-verification-result";
  CustomerSocketTypes2["ndlTreshholdHit"] = "ndl-treshhold-hit";
  CustomerSocketTypes2["userCashbackCalculationUpdated"] = "user-cashback-calculation-updated";
  CustomerSocketTypes2["gbgUserResult"] = "gbg-user-result";
  CustomerSocketTypes2["notificationCenterMsgReceived"] = "notification-received";
  CustomerSocketTypes2["ndlAdjusted"] = "ndl-adjusted";
  CustomerSocketTypes2["userLimitRequestCreated"] = "user-limit-request-created";
  CustomerSocketTypes2["userLimitRequestAlreadyExist"] = "user-limit-request-already-exist";
  CustomerSocketTypes2["userWithdrawalCancelled"] = "user-withdrawal-cancelled";
  return CustomerSocketTypes2;
})(CustomerSocketTypes || {});
const CustomerBasicModal = {
  bonusPicker: "bonusPicker",
  none: "none",
  login: "login",
  logout: "logout",
  register: "register",
  search: "search",
  language: "language",
  registerSuccess: "registerSuccess",
  deposit: "deposit",
  withdrawal: "withdrawal",
  cashier: "cashier",
  producer: "producer",
  cpExchange: "cpExchange",
  forgotPassword: "forgotPassword",
  forgot: "forgot",
  statistics: "statistics",
  wheelOfFortune: "wheelOfFortune",
  wheelOfFortuneSuccess: "wheelOfFortuneSuccess",
  wheelOfFortuneRegistrationError: "wheelOfFortuneRegistrationError",
  recommendedGames: "recommendedGames",
  returnToRegistration: "registrationReturn",
  leagues: "leagues",
  allsports: "allsports",
  betslip: "betslip",
  cabinet: "cabinet",
  documentDetails: "documentDetails",
  documentUpload: "documentUpload",
  transactionDetails: "transactionDetails",
  hotSlotsInfo: "hotSlotsInfo",
  coldSlotsInfo: "coldSlotsInfo",
  instructionsForDownloadingIOS: "instructionsForDownloadingIOS",
  providerCainoSearch: "providerCainoSearch",
  randomSlot: "randomSlot",
  passwordChange: "passwordChange",
  customerPromotions: "customerPromotions",
  recentlyPlayedGames: "recentlyPlayedGames",
  ibanVerificationNotice: "ibanVerificationNotice",
  ondatoVerification: "ondatoVerification",
  casinoSearch: "casinoSearch",
  casinoCategories: "casinoCategories"
};
var CustomerMigrationTypes = /* @__PURE__ */ ((CustomerMigrationTypes2) => {
  CustomerMigrationTypes2["GVIVE_MIGRATION"] = "gvive-step1";
  CustomerMigrationTypes2["ONTARIO_MIGRATION_START"] = "ondato-step1";
  CustomerMigrationTypes2["ONTARIO_OCCUPATION_FORM"] = "ondato-step2";
  return CustomerMigrationTypes2;
})(CustomerMigrationTypes || {});
var UserGroupTypes = /* @__PURE__ */ ((UserGroupTypes2) => {
  UserGroupTypes2["DEFAULT"] = "DEFAULT";
  UserGroupTypes2["MIGRATED"] = "MIGRATED_USERS";
  UserGroupTypes2["ONDATO_VERIFIED"] = "ONDATO_VERIFIED";
  UserGroupTypes2["ONDATO_VERIFICATION_NEEDED"] = "ONDATO_VERIFICATION_NEEDED";
  UserGroupTypes2["GBG_ONDATO"] = "ondato_ver_need";
  UserGroupTypes2["GVIVE_VERIFIED"] = "GVIVE_VERIFIED";
  UserGroupTypes2["SPORT_VIP"] = "sportVip1";
  UserGroupTypes2["YOUNG_ADULT"] = "YOUNG_ADULT";
  return UserGroupTypes2;
})(UserGroupTypes || {});
var CustomerBasicAside = /* @__PURE__ */ ((CustomerBasicAside2) => {
  CustomerBasicAside2["none"] = "none";
  CustomerBasicAside2["main"] = "main";
  CustomerBasicAside2["cabinet"] = "cabinet";
  CustomerBasicAside2["chat"] = "chat";
  return CustomerBasicAside2;
})(CustomerBasicAside || {});
var RegistrationContainers = /* @__PURE__ */ ((RegistrationContainers2) => {
  RegistrationContainers2["modalRegistration"] = "ModalRegistration";
  RegistrationContainers2["registrationPage"] = "RegistrationPageContainer";
  return RegistrationContainers2;
})(RegistrationContainers || {});
var RegistrationStepForm = /* @__PURE__ */ ((RegistrationStepForm2) => {
  RegistrationStepForm2["email"] = "email";
  RegistrationStepForm2["entranceCode"] = "entranceCode";
  RegistrationStepForm2["transactionId"] = "transactionId";
  RegistrationStepForm2["promotion"] = "promotion";
  RegistrationStepForm2["password"] = "password";
  RegistrationStepForm2["repeat"] = "repeat";
  RegistrationStepForm2["emailCode"] = "emailCode";
  RegistrationStepForm2["fitToPlay"] = "isFitToPlay";
  RegistrationStepForm2["currency"] = "currency";
  RegistrationStepForm2["fiscalRegion"] = "fiscalRegion";
  RegistrationStepForm2["country"] = "country";
  RegistrationStepForm2["nationality"] = "nationality";
  RegistrationStepForm2["prefix"] = "prefix";
  RegistrationStepForm2["phone"] = "phone";
  RegistrationStepForm2["phonePrefix"] = "phonePrefix";
  RegistrationStepForm2["postAndAddress"] = "postAndAddress";
  RegistrationStepForm2["address"] = "address";
  RegistrationStepForm2["provinceId"] = "provinceId";
  RegistrationStepForm2["name"] = "name";
  RegistrationStepForm2["surname"] = "surname";
  RegistrationStepForm2["middleName"] = "middleName";
  RegistrationStepForm2["surnamePrefix"] = "surnamePrefix";
  RegistrationStepForm2["personalCode"] = "personalCode";
  RegistrationStepForm2["bsn"] = "bsn";
  RegistrationStepForm2["dob"] = "dob";
  RegistrationStepForm2["birthDay"] = "birthday";
  RegistrationStepForm2["day"] = "day";
  RegistrationStepForm2["month"] = "month";
  RegistrationStepForm2["year"] = "year";
  RegistrationStepForm2["gender"] = "gender";
  RegistrationStepForm2["placeOfBirth"] = "placeOfBirth";
  RegistrationStepForm2["countryIdOfBirth"] = "countryIdOfBirth";
  RegistrationStepForm2["city"] = "city";
  RegistrationStepForm2["street"] = "street";
  RegistrationStepForm2["postcode"] = "postcode";
  RegistrationStepForm2["smsCode"] = "smsCode";
  RegistrationStepForm2["smsRequired"] = "smsRequired";
  RegistrationStepForm2["promoCode"] = "promoCode";
  RegistrationStepForm2["docTypeId"] = "docTypeId";
  RegistrationStepForm2["docNumber"] = "docNumber";
  RegistrationStepForm2["documentType"] = "documentType";
  RegistrationStepForm2["documentNumber"] = "documentNumber";
  RegistrationStepForm2["docIssuedDay"] = "docIssuedDay";
  RegistrationStepForm2["docIssuedMonth"] = "docIssuedMonth";
  RegistrationStepForm2["docIssuedYear"] = "docIssuedYear";
  RegistrationStepForm2["docIssuedDate"] = "docIssuedDate";
  RegistrationStepForm2["docPlaceOfIssue"] = "docPlaceOfIssue";
  RegistrationStepForm2["documentFile"] = "documentFile";
  RegistrationStepForm2["documentName"] = "documentName";
  RegistrationStepForm2["registrationDocTypeId"] = "registrationDocTypeId";
  RegistrationStepForm2["registrationDocNumber"] = "registrationDocNumber";
  RegistrationStepForm2["depositLimitValue"] = "depositLimitValue";
  RegistrationStepForm2["depositLimitPeriod"] = "depositLimitPeriod";
  RegistrationStepForm2["sessionLimitValue"] = "sessionLimitValue";
  RegistrationStepForm2["sessionLimitPeriod"] = "sessionLimitPeriod";
  RegistrationStepForm2["maximumBalanceLimit"] = "maximumBalanceLimit";
  RegistrationStepForm2["balanceResidual"] = "balanceResidual";
  RegistrationStepForm2["wagerLimitPeriod"] = "wagerLimitPeriod";
  RegistrationStepForm2["wagerLimitValue"] = "wagerLimitValue";
  RegistrationStepForm2["singleBetLimit"] = "singleBetLimit";
  RegistrationStepForm2["limitValue"] = "limitValue";
  RegistrationStepForm2["limitType"] = "limitType";
  RegistrationStepForm2["iban"] = "iban";
  RegistrationStepForm2["terms"] = "terms";
  RegistrationStepForm2["confirmCorrectInformation"] = "confirmCorrectInformation";
  RegistrationStepForm2["confirmSane"] = "confirmSane";
  RegistrationStepForm2["confirmOwnAccount"] = "confirmOwnAccount";
  RegistrationStepForm2["confirmNotProhibited"] = "confirmNotProhibited";
  RegistrationStepForm2["confirmNotPoliticallyPerson"] = "confirmNotPoliticallyPerson";
  RegistrationStepForm2["confirmAge"] = "confirmAge";
  RegistrationStepForm2["acceptPolicy"] = "acceptPolicy";
  RegistrationStepForm2["confirmationCode"] = "confirmationCode";
  RegistrationStepForm2["personalIdCountryCode"] = "personalIdCountryCode";
  RegistrationStepForm2["nickName"] = "nickname";
  RegistrationStepForm2["occupationId"] = "occupationId";
  RegistrationStepForm2["taxId"] = "taxId";
  RegistrationStepForm2["residenceCountry"] = "residenceCountry";
  RegistrationStepForm2["citizenship"] = "citizenship";
  RegistrationStepForm2["preferredName"] = "preferredName";
  RegistrationStepForm2["businessTelephoneNumber"] = "businessTelephoneNumber";
  RegistrationStepForm2["employerName"] = "employerName";
  RegistrationStepForm2["employerAddress"] = "employerAddress";
  RegistrationStepForm2["nonAuthBonus"] = "nonAuthBonus";
  RegistrationStepForm2["postcoderAddress"] = "postcoderAddress";
  RegistrationStepForm2["suburb"] = "suburb";
  RegistrationStepForm2["streetName"] = "streetName";
  RegistrationStepForm2["house"] = "house";
  RegistrationStepForm2["socialMethod"] = "socialMethod";
  RegistrationStepForm2["socialMethodSubmit"] = "socialMethodSubmit";
  return RegistrationStepForm2;
})(RegistrationStepForm || {});
var LimitPageTypes = /* @__PURE__ */ ((LimitPageTypes2) => {
  LimitPageTypes2["lossLimits"] = "loss-limits";
  LimitPageTypes2["depositLimits"] = "deposit-limits";
  LimitPageTypes2["sessionLimit"] = "session-limit";
  LimitPageTypes2["balanceLimit"] = "balance-limit";
  LimitPageTypes2["singleBetLimits"] = "single-bet-limits";
  LimitPageTypes2["wagerPerPeriodLimits"] = "wager-per-period-limits";
  LimitPageTypes2["timeout"] = "timeout-limit";
  LimitPageTypes2["balanceResidual"] = "balance-residual-limits";
  return LimitPageTypes2;
})(LimitPageTypes || {});
var SocialMethodStrategy = /* @__PURE__ */ ((SocialMethodStrategy2) => {
  SocialMethodStrategy2["facebook"] = "facebook";
  SocialMethodStrategy2["googleOauth2"] = "google-oauth2";
  return SocialMethodStrategy2;
})(SocialMethodStrategy || {});
const socialMethodToIconMap = {
  [
    "facebook"
    /* facebook */
  ]: "SocialFacebook",
  [
    "google-oauth2"
    /* googleOauth2 */
  ]: "SocialGoogle"
};
export {
  CustomerBasicAside,
  CustomerBasicModal,
  CustomerMigrationTypes,
  CustomerSocketTypes,
  LimitPageTypes,
  RegistrationContainers,
  RegistrationStepForm,
  SocialMethodStrategy,
  UserGroupTypes,
  socialMethodToIconMap
};
